module.exports = "/_next/static/images/empty-dark-e58ae973.png";